<template>
    <section>
        <div class="row">
            <div class="col-md-8">
                <div class="card overflow-hidden">
                    <div class="card-content">
                        <div class="row" id="table-hover-animation">
                            <div class="col-12">
                                <div class="card mb-0">
                                    <div class="card-content">
                                        <div class="card-body">
                                            <table class="table table-hover table-striped mb-0">
                                                <tbody>
                                                <tr>
                                                    <th>Fan nomi</th>
                                                    <td>{{ subject.name }}</td>
                                                </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <subject-sections />
    </section>
</template>

<script>
    import SubjectSections from "./SubjectSections";

    export default {
        name: "SubjectView",

        data() {
            return {
                subject: {},
            }
        },
        components: {
            SubjectSections,
        },
        methods: {
            getSubject() {
                this.$api.get(`admin/Reference/GetSubject/${this.$route.params.id}`)
                    .then(res => {
                        if (!res.error) {
                            this.subject = res.result.data
                        }
                    })
            },
        },
        created() {
            this.getSubject()
        }
    }
</script>

<style scoped>

</style>